import { ShootSummaryInput } from './shootSummary';

export function clientQuoteLink(origin: string, token: string): string {
  return `${origin.replace(/\/+$/, '')}/quote/${token}`;
}

export function clientPaymentLink(origin: string, token: string): string {
  return `${clientQuoteLink(origin, token)}/pay`;
}

export interface QuoteShareDetails {
  clientName?: string;
  quoteNumber: string;
  link: string;
  /** Kept for callers. The message names the quotation and links to it. The date and place stay on the quotation. */
  shoot?: ShootSummaryInput;
}

export function quoteShareText(details: QuoteShareDetails): string {
  const name = details.clientName?.trim() || 'there';
  return `Hello ${name},\n\nThis is your quotation ${details.quoteNumber}.\n\nYour quotation:\n${details.link}\n\nCarmen Lorraine Photography`;
}

/** Returns a mailto-safe recipient, or '' when the address is missing or invalid. */
export function mailtoRecipient(email?: string | null): string {
  const address = String(email || '').trim();
  if (!/^[^\s@,;<>?]+@[^\s@,;<>?]+\.[^\s@,;<>?]+$/.test(address)) return '';
  return address.replace(/[^A-Za-z0-9@.!#$&'*+/=^_`{|}~-]/g, (char) => encodeURIComponent(char));
}

export function quoteEmailLink(details: QuoteShareDetails & { clientEmail?: string | null }): string {
  const subject = `Your quotation ${details.quoteNumber} from Carmen Lorraine Photography`;
  return `mailto:${mailtoRecipient(details.clientEmail)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(quoteShareText(details))}`;
}

export function quoteWhatsAppLink(details: QuoteShareDetails): string {
  return `https://wa.me/?text=${encodeURIComponent(quoteShareText(details))}`;
}
